import Link from "next/link";
import React from "react";
import cn from "classnames";
export default function KnowMore({ className, children, path }) {
  return (
    <Link
      className={cn(
        "text-sm underline text-darkGrey hover:text-darkGrey/50 transition-all duration-300 ease w-fit",
        className
      )}
      href={path ?? "#"}
    >
      {children}
    </Link>
  );
}
